import * as React from 'react';
import { AppMessageBarProps } from "./AppMessageBar.props";
import { MessageBar, Label, concatStyleSets } from 'office-ui-fabric-react';
import { AppLayoutSettings } from "../../pages/common.styles";

/**
 * Teaching Bubble
 * @param props Teaching bubble component properties
 */
export const AppMessageBar: React.FunctionComponent<AppMessageBarProps> = (props: AppMessageBarProps): JSX.Element => {
    return (
        <div style={props.containerStyle}>
          <MessageBar
            styles={props.styles}
            messageBarType={props.messageBarType}
            dismissButtonAriaLabel={props.dismissButtonAriaLabel}
            onDismiss={props.onDismiss}
            isMultiline={true}
            >
            <Label styles={concatStyleSets(AppLayoutSettings.AppCommonStyles.getBoldLabelStyles(AppLayoutSettings.AppFontSize.mediumFontSizePx, AppLayoutSettings.getAppColorContainer().darkLabelColor), props.labelStyles)}>
              {props.headerText}
            </Label>
            <Label styles={concatStyleSets(AppLayoutSettings.AppCommonStyles.getRegularLabelStyles(AppLayoutSettings.AppFontSize.mediumFontSizePx, AppLayoutSettings.getAppColorContainer().mediumLabelColor), props.labelStyles)}>
              {props.children}
            </Label>
          </MessageBar>
        </div>);
}